<template>
    <div
        class="meeting-rating"
        :class="{ loading }"
    >

        <template
            v-if="hasRating && rating > 0"
        >
            <div class="header">Ваша оценка встречи</div>
            <div

                class="rating"
            >
                <font-awesome-icon
                    v-if="rating !== 0"
                    :icon="['fas', $options.rates[rating - 1]]"
                    class="rating__item selected"
                    size="3x"
                />
            </div>
        </template>
        <template
            v-else-if="hasRating && rating === 0"
        >
            <div class="header">Встреча не состоялась</div>
            <div
                class="confirm active"
                @click="hasRating = false"
            >
                Изменить решение
            </div>
        </template>
        <template
            v-else
        >
            <div class="header">Оцените прошедшую встречу</div>
            <div class="rating">
                <font-awesome-icon
                    v-for="(icon, i) in $options.rates"
                    :key="i"
                    :icon="[ selected === i + 1 ? 'fas' : 'far', icon]"
                    class="rating__item"
                    :class="{selected: selected === i + 1}"
                    @click="selected = i + 1"
                    size="3x"
                />
            </div>
            <div
                class="missed"
                @click="setMissed"
                :class="{ loading }"
            >
                Встреча не состоялась
            </div>
            <div
                class="confirm"
                :class="{ active: selected, loading }"
                @click="confirm"
            >
                Подтвердить
            </div>
        </template>
    </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
    name: 'MeetingRating',
    props: {
        meetingId: {
            type: Number,
            required: true,
        },
        rating: {
            type: Number,
            required: false,
        },
    },
    rates: [
        'frown',
        'meh',
        'smile',
    ],
    data: () => ({
        selected: null,
        loading: false,
        hasRating: false,
    }),
    watch: {
        rating() {
            this.setCurrentRating();
        },
    },
    mounted() {
        this.setCurrentRating();
    },
    methods: {
        ...mapActions('mentoring/activities', [
            'rateMeeting',
        ]),
        setCurrentRating() {
            this.hasRating = this.rating !== null;
            this.selected = this.rating;
        },
        setMissed() {
            this.selected = 0;
            this.confirm();
        },
        async confirm() {
            this.loading = true;
            await this.rateMeeting({ meeting_id: this.meetingId, rating: this.selected });
            this.loading = false;
            this.hasRating = true;
            this.$emit('update');
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../../../styles/rem';

    .meeting-rating {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background: #F2F2F2;
        padding: rem(24);
        margin-bottom: rem(32);

        @include on-mobile {
            padding: mrem(24);
            margin-bottom: mrem(32);
        }

        .header {
            font-weight: 600;
            font-size: rem(16);
            line-height: rem(24);
            color: #2A2626;
            margin-bottom: rem(16);

            @include on-mobile {
                font-size: mrem(16);
                line-height: mrem(24);
                margin-bottom: mrem(16);
            }
        }

        .rating {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            .rating__item {
                width: rem(50);
                height: rem(50);
                border-radius: 50%;
                background: white;
                margin: 0 rem(20);
                cursor: pointer;
                color: #CCCCCC;

                @include on-mobile {
                    width: mrem(50);
                    height: mrem(50);
                    margin: 0 mrem(20);
                }

                &.selected {
                    color: #FFD633;
                }
            }
        }

        .missed {
            margin-top: rem(24);
            font-weight: 600;
            font-size: rem(14);
            line-height: rem(20);
            color: #4663AB;
            padding-bottom: 1px;
            border-bottom: 1px solid #4663AB;
            cursor: pointer;
            margin-bottom: rem(24);
            user-select: none;

            @include on-mobile {
                margin-top: mrem(24);
                font-size: mrem(14);
                line-height: mrem(20);
                margin-bottom: mrem(24);
            }

            &.loading {
                cursor: wait;
            }
        }

        .confirm {
            width: rem(320);
            height: rem(32);
            border-radius: rem(32);
            font-weight: 600;
            font-size: rem(14);
            line-height: rem(20);
            padding: rem(6);
            text-align: center;
            color: #CCCCCC;
            border: 1px solid #CCCCCC;

            @include on-mobile {
                width: mrem(320);
                height: mrem(32);
                border-radius: mrem(32);
                font-size: mrem(14);
                line-height: mrem(20);
                padding: mrem(6);
            }

            &.active {
                border: 1px solid #4663AB;
                cursor: pointer;
                background: #4663AB;
                color: #FFFFFF;

                &.loading {
                    cursor: wait;
                }
            }
        }
    }
</style>